<div class="send-bubble">
  <span>{{ message()?.message }}</span>
</div>
